export function formatBytes(bytes, decimals) {
  if (bytes < 0) return 'NaN'
  if (bytes === 0) return '0 KB'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  // remove Bytes
  const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
